<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    formControlName="reason"
                    direction="column"
                    [isDefault]="false"
                    [options]="options"
                    columns="1"
                  >
                  </pr-input-radio>
                </div>
              </div>
              @if (
                form.get('products').at(0).get('parameters.reason').value ===
                'AUTRE'
              ) {
                <div class="row">
                  <pr-input-column
                    label="Précision sur le motif de l'opération :"
                    [derrors]="derrors"
                    [isDefault]="false"
                  >
                    <textarea
                      class="full-w"
                      type="text"
                      placeholder="Commencez à écrire ici"
                      rows="6"
                      formControlName="reasonComment"
                    ></textarea>
                  </pr-input-column>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
